export class ActivateUserUtil {
    static getStatusFromMessage = (message) => {
        if(message)
        {
            let messageFromResponse =  !(message.split("-")[1]) ? "" :   message.split("-")[1].trim();
            return messageFromResponse;
        }
    }
}